// extracted by mini-css-extract-plugin
module.exports = {"stepTitle":"CreateApplicationForm_stepTitle__3jqtn"};